import React, { useState } from "react";
import { Autocomplete as GooglePlacesAutocomplete } from "@react-google-maps/api";
import {
  InputAdornment,
  IconButton,
  Button,
  TextField,
  Grid as Grid,
  styled,
  LinearProgress,
  linearProgressClasses,
  Typography
} from "@mui/material";
import { Box } from "@mui/system";
import { BIBlue } from "../../assets/helpers";
import { Clear, Search } from "@mui/icons-material";
// import "./createaccount.css";
import { Postrequestcall } from "../../request/Postrequest";
import { UPDATE_VARIFIED_DETAILS } from "../../constant/Apipath";
import BuildIDLogo from "../../assets/images/build_id_logo.png";
import { useSelector } from "react-redux";
import { setShowalert } from "../../redux/actions/actions";
import { useDispatch } from "react-redux";

export const ProfilePage = (props) => {
  const {
    handleFirstNameInput,
    searchTerm,
    setSearchTerm,
    handleLastNameInput,
    email,
    firstName,
    lastName,
    gotoTradeAndProfilePage,
    openProfilePage,
    loadingPage
  } = props;
  // const [searchTerm, setSearchTerm] = useState({
  //     city: "",
  //     country: "",
  //     latitude: "",
  //     longitude: "",
  // });
  const [autocomplete, setAutocomplete] = useState(null); // Google Places Autocomplete API instance
  const { loginData } = useSelector((state) => state.main);
  const dispatch = useDispatch();
  const { UserId } = loginData?.userInformation;
  const { accessToken } = loginData;

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 5,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 200 : 800]
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? BIBlue : "#308fe8"
    }
  }));

  const onLoadAuto = (newInstance) => {
    // Access the suggestion list container and add a custom class
    setAutocomplete(newInstance);
  };

  const handleSearch = async () => {
    let place = autocomplete.getPlace();

    if (place.geometry) {
      const latitude = place.geometry.location.lat();
      const longitude = place.geometry.location.lng();

      // Extract city and country
      const city =
        place.address_components?.find((comp) => comp.types.includes("locality"))?.long_name ||
        place.formatted_address;

      const country = place.address_components?.find((comp) =>
        comp.types.includes("country")
      )?.long_name;

      setSearchTerm({
        city: city,
        country: country,
        latitude: latitude,
        longitude: longitude,
        formatted_address: place.formatted_address || city
      });
    }
  };

  const handleSearchTermClear = () => {
    setSearchTerm({
      city: "",
      country: "",
      latitude: "",
      longitude: "",
      formatted_address: ""
    });
  };

  const handleNextClick = async () => {
    loadingPage();
    try {
      const obj = {
        UserId: UserId,
        FirstName: firstName ?? "",
        LastName: lastName ?? "",
        Email: email,
        City: searchTerm.city ?? "",
        Country: searchTerm.country ?? "",
        Latitude: searchTerm.latitude ?? 0.0,
        Longitude: searchTerm.longitude ?? 0.0
      };

      const updateVarifiedRes = await Postrequestcall(UPDATE_VARIFIED_DETAILS, obj, accessToken);
      if (
        (updateVarifiedRes?.data?.errorMessage ===
          "Your first name contains a restricted word. Please Choose another." ||
          updateVarifiedRes?.data?.errorMessage ===
            "Your last name contains a restricted word. Please Choose another.") &&
        updateVarifiedRes?.data?.status === false
      ) {
        let alertObj = {
          showAlert: true,
          title: "",
          text: updateVarifiedRes?.data?.errorMessage
        };
        dispatch(setShowalert(alertObj));
        openProfilePage();
      } else if (
        updateVarifiedRes?.data?.message === "OK" &&
        updateVarifiedRes?.data?.status === true
      ) {
        gotoTradeAndProfilePage();
      }
    } catch (error) {
      console.log("handleNextClick-> Error When Updating Verification Details: ", error);
      openProfilePage();
    }
  };

  return (
    <Box component="form">
      <Grid container sx={{ flexDirection: "column" }} spacing={2}>
        <Grid item>
          <img src={BuildIDLogo} alt="" style={{ display: "block", margin: "0 auto" }} />
        </Grid>
        <Grid sx={{ justifyContent: "center" }}>
          <BorderLinearProgress variant="determinate" value={33.33} />
          <Grid sx={{ display: "flex", justifyContent: "space-between" }} item size= {{ xs: 6 }}>
            <Typography variant="caption" sx={{ textAlign: "left" }}>
              Profile
            </Typography>
            <Typography variant="caption" sx={{ textAlign: "right" }}>
              1/3
            </Typography>
          </Grid>
        </Grid>
        {/* <Grid container sx={{ alignItems: "center",  justifyContent: "space-between" }} > */}

        {/* </Grid> */}
        <Grid item size={{ xs:12 }}>
          <TextField
            fullWidth
            label="First Name"
            type="text"
            value={firstName}
            onChange={handleFirstNameInput}
            variant="outlined"
          />
        </Grid>
        <Grid item size={{ xs:12 }}>
          <TextField
            fullWidth
            label="Last Name"
            type="text"
            value={lastName}
            onChange={handleLastNameInput}
            variant="outlined"
          />
        </Grid>
        <Grid item size={{ xs:12 }}>
          <TextField
            fullWidth
            label="Email"
            type="email"
            value={email}
            disabled
            variant="outlined"
          />
        </Grid>
        <Grid item size={{ xs:12 }}>
          <div>
            <GooglePlacesAutocomplete
              style={{ position: "relative" }}
              onLoad={(newInstance) => onLoadAuto(newInstance)}
              onPlaceChanged={handleSearch}
              options={{
                componentRestrictions: { country: ["US", "CA", "GB"] } // Restrict to USA, Canada, and UK
              }}>
              <TextField
                variant="outlined"
                placeholder="City"
                fullWidth
                value={searchTerm?.formatted_address}
                onChange={(event) => setSearchTerm(event.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {searchTerm?.formatted_address && (
                        <IconButton onClick={handleSearchTermClear}>
                          <Clear />
                        </IconButton>
                      )}
                    </InputAdornment>
                  ),
                  startAdornment: <Search style={{ color: "gray", marginRight: "10px" }} />
                }}
              />
            </GooglePlacesAutocomplete>
          </div>
        </Grid>
      </Grid>

      <Box sx={{ mt: 4,  textAlign: "center" }} >
        <Button
          variant="contained"
          size="large"
          fullWidth
          disabled={firstName === "" || lastName === ""}
          sx={{ maxWidth: 300, background: BIBlue }}
          onClick={handleNextClick}>
          Next
        </Button>
      </Box>
    </Box>
  );
};
